import getIn from 'transmute/getIn';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import I18n from 'I18n';
import { ENROLLMENT_DATASET } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getDefaultName = prefix => {
  if (prefix === ENROLLMENT_DATASET) {
    return I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.datasets.option');
  }
  return null;
};
const DataSourceName = ({
  dataSourcePrefix,
  token
}) => {
  const tokenParts = getTokenParts(token);
  let dataSourceName = '';
  const prefix = tokenParts.prefix || dataSourcePrefix || '';
  const {
    data,
    loading,
    error
  } = useGetDataSource({
    prefix
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-loader-data-source-name"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "property"
    });
  }
  if (data) {
    const label = getIn(['dataSourceDefinition', 'label'], data);
    if (label) {
      dataSourceName = label;
    } else {
      dataSourceName = getDefaultName(prefix) || '';
    }
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dataSourceName
  });
};
export default DataSourceName;